import { Italian } from "flatpickr/dist/l10n/it.js"
flatpickr.localize(Italian);
